<div class="inner-container" *ngIf="depositStep === 1">
  <div class="header">
    <img
      class="back-button"
      (click)="back()"
      src="assets/icons/news/back-arrow.svg"
      alt="back button"
    />

    <div class="title-container">
      <h3>Ingresá crypto</h3>
      <p>¿Desde dónde vas a enviar?</p>
    </div>
  </div>

  <div class="options">
    <div class="option small" (click)="goToDepositStep(3)">
      <p class="title">BNB Chain (BEP-20)</p>
      <img src="assets/icons/crypto/bnb.svg" alt="BNB option" />
      <p class="subtitle">Sin mínimos de depósito.</p>
    </div>

    <div class="option small" (click)="goToDepositStep(4)">
      <p class="title">Ethereum</p>
      <img src="assets/icons/news/ethereum-network.svg" alt="external option" />
      <p class="subtitle">Mínimo de 100 USD.</p>
    </div>

    <div class="option small" (click)="goToDepositStep(7)">
      <p class="title">Polygon</p>
      <img src="assets/icons/news/polygon-network.svg" alt="external option" />
      <p class="subtitle">Sin mínimos de depósito.</p>
    </div>
  </div>
</div>

<!-- WALLET PROPIO, BINANCE OR EXTERNAL -->
<div class="inner-container" *ngIf="depositStep >= 3">
  <img
    class="back-button"
    (click)="back()"
    src="assets/icons/news/back-arrow.svg"
    alt="back button"
  />

  <div class="title-container">
    <h3>Ingresá crypto</h3>
    <p>Seleccioná una billetera</p>
  </div>

  <div class="no-address" *ngIf="!address && auth.loggedUser.isCommerce">
    <app-reminder-message
      message="De momento los depósitos de criptomonedas no están disponibles para los usuarios de Commerce."
      type="warning"
    >
    </app-reminder-message>
    <button class="td-btn primary" (click)="close()">Aceptar</button>
  </div>

  <div class="no-address" *ngIf="!address && this.depositStep === 5">
    <app-reminder-message
      message="En este momento la red no está procesando transacciones. No realizar depósitos."
      type="warning"
    >
    </app-reminder-message>
    <button class="td-btn primary" (click)="close()">Cerrar</button>
  </div>

  <div class="address-container" *ngIf="address">
    <mat-form-field *ngIf="depositableCoins?.length" class="select-crypto" appearance="outline">
      <mat-select
        [formControl]="cryptoSelected"
        class="crypto-ticker"
        [class.stabless]="cryptoSelected.value === 'STABLES'"
      >
        <mat-select-trigger style="display: flex; align-items: center; gap: 0.5em">
          <img
            class="option-img"
            [src]="'assets/icons/crypto/' + cryptoSelected.value.toLowerCase() + '.svg'"
            width="24"
            height="24"
            alt="icon"
          />
          <span class="option-description">
            {{ cryptoSelected.value }}
            <span *ngIf="cryptoSelected.value === 'USDC'"> (Nativo) </span>
          </span>
        </mat-select-trigger>
        <mat-option *ngFor="let coin of depositableCoins" [value]="coin">
          <img
            class="option-img"
            [class.stables]="coin === 'STABLES'"
            [src]="'assets/icons/crypto/' + coin.toLowerCase() + '.svg'"
            width="24"
            alt="coinicon"
          />
          <span class="option-description"> {{ coin }} - {{ getCoinFullName(coin) }} </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
    <div class="reminder" *ngIf="!depositableCoins?.length">
      <app-reminder-message
        message="Los depósitos en esta red están momentameante deshabilitados."
        type="warning"
      >
      </app-reminder-message>
    </div>

    <div class="reminder" *ngIf="depositStep === 3 && cryptoSelected.value === 'BTC'">
      <app-reminder-message
        message="Al momento, los depósitos de BTC serán única y exclusivamente a través de la red de Binance (BSC)."
        type="warning"
      >
      </app-reminder-message>
    </div>

    <div class="reminder">
    <app-reminder-message
        message="No se admiten depósitos de BingX y FixedFloat."
        type="error"
      >
    </app-reminder-message>
  </div>

    <div class="address-left" *ngIf="cryptoSelected.value !== 'BUSD'">
      <b *ngIf="depositStep === 3">Enviá los {{ cryptoSelected.value }} vía BNB Chain (BEP-20)</b>
      <b *ngIf="depositStep === 4">Enviá los {{ cryptoSelected.value }} vía Ethereum (ERC20)</b>
      <b *ngIf="depositStep === 7">Enviá los {{ cryptoSelected.value }} vía Polygon</b>
      <small>Tiempo estimado: 3 minutos</small>
      <p class="address-label">Dirección de envío</p>
      <div></div>
      <div class="address">
        <div class="option" *ngIf="address">
          <div *ngIf="!addressLoading; else addressLoader" class="left">
            <p>{{ address }}</p>
          </div>
        </div>
        <div *ngIf="!addressLoading" class="right">
          <img
            src="assets/icons/news/copy_violet.svg"
            alt="copy"
            *ngIf="!copied; else addressCopied"
            (click)="copyCBUToClipboard()"
          />
          <ng-template #addressCopied>
            <img class="copied" src="assets/icons/checked-onboarding.svg" alt="copied" />
          </ng-template>
        </div>
        <ng-template #addressLoader>
          <div class="loading">
            <div class="circle-loader">
              <div class="checkmark draw"></div>
            </div>
          </div>
        </ng-template>
      </div>

      <p class="txt-info">
        Verificá que la dirección y la red sean correctas. Tené en cuenta que el depósito se hace
        después de las <span class="highlight">12</span> confirmaciones.
      </p>
    </div>

    <div class="qr" *ngIf="cryptoSelected.value !== 'BUSD'">
      <ngx-qrcode
        [elementType]="elementType"
        [errorCorrectionLevel]="correctionLevel"
        [value]="qrValue"
      ></ngx-qrcode>
    </div>

    <button class="td-btn primary" (click)="close()">Listo</button>
  </div>
</div>
